import { cognito } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import * as LS from 'helpers/localStorage';
import { call, put, select } from 'redux-saga/effects';
import { AuthData, ChangePasswordSubmitState } from 'types';

import { authSignIn } from './authSignIn';

type Payload = Required<ChangePasswordSubmitState>;

export const authCompleteNewPassword = createApiSlice<unknown, Payload>({
  name: 'authCompleteNewPassword',
  *tryGenerator(_, { payload: { password, newPassword } }) {
    const { keepSession, ...authData } = yield select(authSignIn.selectors.getData);

    const data: AuthData = yield call(cognito.completeNewPassword, {
      authData,
      password,
      newPassword,
    });

    // update AuthData
    const fullData = { ...data, keepSession };
    LS.updateField({ field: 'authSignIn', data: fullData });

    yield put(authSignIn.actions.success(fullData));
    yield put(authSignIn.actions.completed());

    return null;
  },
});
